module.exports = __webpack_public_path__ + "static/media/pictureofme.7b414c51.jpg";